// @flow

import { createSelector } from 'reselect';

import {
  selectProductsByType,
  type DecoratedProduct,
  type Process,
} from '@gandi/cart';
import type { Fqdn } from '@gandi/domain-configuration';

import type { MailboxType } from '../../modules/mailbox/offers';
import type { FullState } from '../../types';

const productType = { productType: 'mailboxv2' };
/**
 * Return mailboxes of the defined type.
 */
export type SelectMailboxProductArgs = {
  fqdn?: Fqdn,
  type: MailboxType,
  process: Process,
};
export const selectMailboxProduct: (
  FullState,
  SelectMailboxProductArgs,
) => void | DecoratedProduct = createSelector(
  (state, props) => props,
  state => selectProductsByType(state, productType),
  (props: SelectMailboxProductArgs, products: Array<DecoratedProduct>) =>
    products.filter(
      ({ payload, process: productProcess }) =>
        payload.mailbox_type === props.type &&
        payload.fqdn === props.fqdn &&
        productProcess === props.process,
    )[0],
);
